import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Card, CardBody, Media, Button,
  Modal, ModalHeader, ModalBody, ModalFooter, TabPane,
} from 'reactstrap'
import moment from 'moment'
import DataTable from '../../../components/Template/Table/DataTable'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import FinancialResultGraph from '../FinancialResultGraph'
import PieChart from '../../../utils/chart/PieChart'
import FinCard from '../../../utils/card/FinCard'
import FinResultCard from '../../../utils/card/FinResultCard'
import graphRequest from '../../../utils/graphRequest/index'
import api_powerapps from '../../../services/powerapps/index'
import * as XLSX from 'xlsx'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Box, Stack } from '@mui/material'
import {MaterialReactTable} from 'material-react-table'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { ExportToCsv } from 'export-to-csv'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import DBTable from '../../../components/Template/Table/DBTable'

class Orcamento extends Component {
  constructor(props) {
    super(props)
    this.state = {
      time: moment(),
      mes: null,
      getDataIsLoading: false,
      data: false,
      data_mensal: false,
      orcamentoModalIsOpen: false,
      oikos_usuario: false,
      oikos_senha: false,
    }
  }

  componentDidMount() {
    this.credentialsOikos()
    this.getData()
  }

  credentialsOikos = async() => {
    const formData = new FormData()
    try {
      // início da requisição
      formData.append('acao', 'get_credentials') // objeto enviado com a requisição indicando a rota
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.log('login:', res.data) // debug
      this.setState({ oikos_usuario: res.data.usuario_login, oikos_senha: res.data.usuario_senha})
    } catch (err) {
      console.log('Não foi possível logar no Oikos.', err)
    }
  }

  getData = async () => {
    this.setState({ getDataIsLoading: true })
    const formData = new FormData()
    try {
      // início da requisição
      formData.append('acao', 'orcamento') // objeto enviado com a requisição indicando a rota
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.tron.log('data', Object.values(res.data)) // debug
      const { data } = res // extração de dados da requisição
      console.log('data:', data) // debug
      this.setState({ getDataIsLoading: false, data: data }) // salva dados que vieram da requisição para dentro da variável de estado
    } catch (err) {
      this.setState({ getDataIsLoading: false, data: false })
      console.log('Não foi possível carregar a série de dados a partir do MySQL.', err)
    }
  }

  handleExportXLSX = () => {
    const { time, mes, data, data_mensal } = this.state
    var wb = XLSX.utils.book_new()
    var ws1b = XLSX.utils.aoa_to_sheet([
        ['Receita Acumulada', data.receita_real],
        ['Despesa Acumulada', data.despesa_real],
        ['Resultado Acumulado', data.resultado_real],
      ]
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Receita Orçada', data.receita_orcada],
        ['Despesa Orçada', data.despesa_orcada],
        ['Resultado Orçado', data.resultado_orcado],
      ],
      {origin: "A5"}
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Receita Atualizada', data.receita_atualizada],
        ['Despesa Atualizada', data.despesa_atualizada],
        ['Resultado Atualizado', data.resultado_atualizado],
      ],
      {origin: "A9"}
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Margem de Contribuição', data.margemcontribuicao_futura],
        ['Necessidade de receita', data.necessidade_receita],
      ],
      {origin: "A13"}
    )

    //XLSX.utils.sheet_add_aoa(ws1b, data_mensal, { origin: 'A13', skipHeader: true })
    console.log('mensal:', data_mensal)
    let aux_data_mensal = Array()
    Object.keys(data_mensal).forEach((key) => {
      let aux = Array()
      Object.entries(data_mensal[key]).forEach((item)=>{
        aux[item[0]] = item[1]
      })
      aux_data_mensal[key] = aux
    })
    let aux_meses = Object.keys(data_mensal)
    console.log(aux_meses)
    //XLSX.utils.sheet_add_json(ws1b, aux_data_mensal, { origin: "A16" } )*/

    let aux_table = []
    aux_table['mes'] = []
    aux_table['mes'].push('Meses')
    aux_table['receita'] = []
    aux_table['receita'].push('Receita')
    aux_table['despesa'] = []
    aux_table['despesa'].push('Despesa')
    aux_table['resultado'] = []
    aux_table['resultado'].push('Resultado')
    aux_table['acumulado'] = []
    aux_table['acumulado'].push('Acumulado')

    aux_meses.map((mes) => {
      aux_table['mes'].push(aux_data_mensal[mes]['mes'])
      aux_table['receita'].push(aux_data_mensal[mes]['receita'])
      aux_table['despesa'].push(aux_data_mensal[mes]['despesa'])
      aux_table['resultado'].push(aux_data_mensal[mes]['resultado'])
      aux_table['acumulado'].push(aux_data_mensal[mes]['acumulado'])
    })

    XLSX.utils.sheet_add_aoa(ws1b, [
      aux_table['mes'],
      aux_table['receita'],
      aux_table['despesa'],
      aux_table['resultado'],
      aux_table['acumulado'],
    ], {origin: "A16"})

    console.log(aux_table)

    XLSX.utils.book_append_sheet(wb, ws1b, 'Dashboard')

    console.log(aux_data_mensal)

    XLSX.writeFile(wb, 'DashboardFinanceiro.xlsx')
  }

  render() {
    const { oikos_usuario, oikos_senha, time, mes, data, orcamentoModalIsOpen, getDataIsLoading } = this.state
    let ptBR = Intl.NumberFormat("pt-BR", {
      style: "decimal",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })

    const columns = [
      [
        {
          accessorKey: 'cc',
          header: 'Centro de Custo',
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                TOTAL
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'rubr',
          header: 'Rubricas',
        },
        {
          accessorKey: 'fluxo',
          header: 'Fluxo',

        },
        {
          accessorKey: 'orcado',
          header: 'Orçado Inicial',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[0].reduce((acc, curr) => acc + curr.orcado, 0)?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'atualizado',
          header: 'Orçado Atual',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[0].reduce((acc, curr) => acc + curr.atualizado, 0)?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'realizado',
          header: 'Realizado',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[0].reduce((acc, curr) => acc + curr.realizado, 0)?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
      ],
      [
        {
          accessorKey: 'cc',
          header: 'Centro de Custo',
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                TOTAL
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'rubr',
          header: 'Rubricas',
        },
        {
          accessorKey: 'atualizado',
          header: 'Previsto',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[0].reduce((acc, curr) => acc + curr.atualizado, 0)?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'join',
          header: 'Lançado',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[0].reduce((acc, curr) => acc + curr.join, 0)?.toLocaleString?.('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
      ],
      [
        {
          accessorKey: 'fluxo',
          header: 'Fluxo',

        },
        {
          accessorKey: 'cc',
          header: 'Centro de Custo',
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                TOTAL
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'rubr',
          header: 'Rubricas',
        },
        {
          accessorKey: 'total',
          header: 'Total',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.total ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_01',
          header: 'jan/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_01 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_02',
          header: 'fev/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_02 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_03',
          header: 'mar/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
              {data[1].reduce((acc, curr) => acc + (curr.mes_03 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_04',
          header: 'abr/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_04 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_05',
          header: 'mai/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_05 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_06',
          header: 'jun/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_06 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_07',
          header: 'jul/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_07 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_08',
          header: 'ago/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_08 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_09',
          header: 'set/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_09 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_10',
          header: 'out/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_10 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_11',
          header: 'nov/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_11 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },
        {
          accessorKey: 'mes_12',
          header: 'dez/2024',
          muiTableHeadCellProps: {
            align: 'right',
          },
          muiTableFooterCellProps: {
            align: 'right',
          },
          muiTableBodyCellProps: {
            align: 'right',
          },
          aggregationFn: 'sum',
          AggregatedCell: ({ cell, table }) => (
            <>
              <Box sx={{ fontWeight: 'bold' }}>
                {cell.getValue()?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </>
          ),
          Cell: ({ cell }) => (
            <>
              {cell.getValue()?.toLocaleString?.('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </>
          ),
          Footer: () => (
            <Stack>
              <Box sx={{ fontWeight: 'bold' }}>
                {data[1].reduce((acc, curr) => acc + (curr.mes_12 ?? 0), 0)?.toLocaleString?.('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Stack>
          ),
        },


      ],
    ]

    const csvOptions = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalSeparator: ',',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: columns[0].map((c) => c.header),
    }

    const csvExporter = new ExportToCsv(csvOptions)

    const xlsxExporter = (data, header) => {
      const dadosComHeadersRenomeados = data.map((dado) => {
        const novoDado = {}
        header.forEach((coluna) => {
          novoDado[coluna.header] = dado[coluna.id]
        })
        return novoDado
      })

      const sheetOptions = {
        header: header.map((coluna) => coluna.header)
      }

      const worksheet = XLSX.utils.json_to_sheet(dadosComHeadersRenomeados, sheetOptions)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
      XLSX.writeFile(workbook, 'dados.xlsx')
    }

    const pdfExporter = (data, header) => {
      const dadosComHeadersRenomeados = data.map((dado) => {
        const novoDado = {}
        header.forEach((coluna) => {
          if (typeof dado[coluna.id] === "number") {
            novoDado[coluna.header] = dado[coluna.id].toLocaleString?.('pt-BR', {

              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          } else {
            novoDado[coluna.header] = dado[coluna.id]
          }
        })
        return novoDado
      })

      // Cria a tabela a partir dos dados renomeados
      const headers = header.map((coluna) => coluna.header)
      const rows = dadosComHeadersRenomeados.map((dado) => Object.values(dado))
      const table = [headers, ...rows]

      // Cria o objeto jsPDF
      const doc = new jsPDF()

      // Adiciona a tabela ao documento
      doc.autoTable({
        head: [headers],
        body: rows,
      })

      // Salva o arquivo
      doc.save('dados.pdf')
    }

    const handleExportData = (exportFormat) => {
      switch (exportFormat) {
        case 'xlsx':
          xlsxExporter(data[0], columns[0])
          break
        case 'csv':
          csvExporter.generateCsv(data[0])
          break
        case 'pdf':
          pdfExporter(data[0], columns[0])
          break
        default:
          console.log('Formato não reconhecido')
      }
    }

    if (data) {
      console.log("data no render:", data)
      return (
          <>
          <div className="page-content">
            <Container fluid>
              <Breadcrumbs
                title="Meus Orçamentos"
                breadcrumbItems={[{
                  title: (moment(time).format('dddd, DD [de] MMMM [de] YYYY, HH:mm')).toLowerCase(),
                }]}
              />

            <Tabs>
              <TabList>
                <Tab>Orçamento Anual - Acompanhamento</Tab>
                <Tab>Orçamento Anual - Por Mês</Tab>
                {/*<Tab>Orçamento Mensal - Acompanhamento</Tab>*/}
                <Tab>Orçamento Anual - Gestão</Tab>
                {/*<Tab>DBTable</Tab>*/}
              </TabList>

              <TabPanel>
                <Row className="mt-3 mb-3">
                  <Col>
                    <h4>
                      Orçamento Anual - Agregado
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MaterialReactTable
                      columns={columns[0]}
                      data={data[0]}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                          sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                        >
                          <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={() => handleExportData('csv')}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            CSV
                          </Button>
                          <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={() => handleExportData('xlsx')}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            XLSX
                          </Button>
                          <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={() => handleExportData('pdf')}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            PDF
                          </Button>
                        </Box>
                      )}
                      initialState={{
                        columnVisibility: { fluxo: true },
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        grouping: ['cc'], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [{ id: 'atualizado', desc: true }], //sort by state by default
                      }}
                      enableGrouping
                      enableGlobalFilter
                      enableFilters
                      enablePagination={false}
                    />
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel>
                <Row className="mt-3 mb-3">
                  <Col>
                    <h4>
                      Orçamento Anual - Por Mês
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                  <MaterialReactTable
                      columns={columns[2]}
                      data={data[1]}
                      initialState={{
                        columnVisibility: { fluxo: true },
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        grouping: ['cc'], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [{ id: 'mes_01', desc: true }], //sort by state by default
                        columnPinning: { left: ['cc', 'rubr','fluxo'] }
                      }}
                      enableGrouping
                      enableGlobalFilter
                      enableFilters
                      enablePinning
                      enablePagination={false}
                    />
                  </Col>
                </Row>
              </TabPanel>

              {/*<TabPanel>
                <Row className="mt-3 mb-3">
                  <Col>
                    <h4>
                      Orçamento Mensal - Acompanhamento
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MaterialReactTable
                      columns={columns[1]}
                      data={data[2]}
                      initialState={{
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        grouping: ['cc'], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [{ id: 'atualizado', desc: true }], //sort by state by default
                      }}
                      enableGrouping
                      enableGlobalFilter
                      enableFilters
                      enablePagination={false}
                    />
                  </Col>
                </Row>

              </TabPanel>*/}


              <TabPanel>
                <Row className="mt-3 mb-3">
                  <Col>
                    <h4>
                      Orçamento Anual - Gestão
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Card>
                      <CardBody>
                        <iframe src={`https://oikos.ecoss.is/oikos/planilha.orcamento2024.single.php?login123=${oikos_usuario}&pass123=${oikos_senha}`} frameBorder="0" width="100%" height="600" />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel>
                <Row className="mt-3 mb-3">
                  <Col>
                    <Card>
                      <CardBody>
                        <DBTable
                          Table="pf"
                          Columns={[
                            {accessorKey: 'pf_dtNasc', header: 'Data de Nascimento'},
                          ]}
                        >
                        </DBTable>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPanel>
            </Tabs>
            </Container>


          </div>

            <Modal
            size="xl"
            centered
            isOpen={orcamentoModalIsOpen}
            toggle={() => this.setState({ orcamentoModalIsOpen: false })}
            >
            <ModalHeader
              toggle={() => this.setState({ orcamentoModalIsOpen: false })}
            >
              Gerenciar orçamentos
            </ModalHeader>
            <ModalBody
              height="800"
            >
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="light"
                className="waves-effect waves-light"
                onClick={() => this.setState({ orcamentoModalIsOpen: false })}
              >
                Fechar
              </Button>
            </ModalFooter>
            </Modal>
          </>
        )
      }
      return null
    }
  }


const mapStateToProps = state => ({ financial: state.financial, auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Orcamento)
